<form novalidate #motorsDescriptionAndPhotosDescriptionSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col>
            <tg-row>
                <tg-col md="6" sm="12">
                    <tg-input-container label="Listing title" [description]="titleDescription" showRemainingCharacters="false">
                        <input
                            tgTextInput
                            size="small"
                            (blur)="publish()"
                            name="listingTitle"
                            placeholder="e.g. 2018 Yamaha Aluminium hull boat"
                            [(ngModel)]="draftData.descriptionAndPhotos.listingTitle"
                            [validation]="listingTitleValidation()"
                            [disabled]="isDisabledTitle"/>
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="6" sm="12">
                    <tg-input-container label="Add your subtitle" [showRemainingCharacters]="!isDisabledSubTitle">
                        <input
                            tgTextInput
                            size="small"
                            (blur)="publish()"
                            name="subTitle"
                            [placeholder]="'e.g. NZ new, great condition, quick sale wanted'"
                            [(ngModel)]="draftData.descriptionAndPhotos.subTitle"
                            [validation]="subtitleValidation()"
                            [disabled]="isDisabledSubTitle" />
                    </tg-input-container>
                    <p [hidden]="!isDisabledSubTitle" class="motors-description-and-photos-description-section__subtitleText">Select a Premium package if you would like to add a subtitle to your listing</p>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="6" sm="12">
                    <tg-input-container label="Description">
                        <textarea
                            tgTextInput
                            name="description"
                            rows="15"
                            type="text"
                            (blur)="publish()"
                            placeholder="e.g. condition and other information"
                            [(ngModel)]="draftData.descriptionAndPhotos.description"
                            [validation]="validation.descriptionAndPhotos.description | toValidator"
                            [disabled]="isDisabledDescription">
                        </textarea>
                    </tg-input-container>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
